import type { TContractType } from '@/entities/contract'

/** URL slug ↔ contract type; the builder page is addressable per document. */
export const CONTRACT_TYPE_BY_SLUG: Record<string, TContractType> = {
  processing: 'PROCESSING',
  procurement: 'PROCUREMENT',
}

export const CONTRACT_SLUG_BY_TYPE: Record<TContractType, string> = {
  PROCESSING: 'processing',
  PROCUREMENT: 'procurement',
}
